import React from 'react'

export default function POListHeaderStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #refresh-list:hover .tooltip-text { left: 0%; }
        #refresh-list:hover .tooltip-text::after { left: 30%; }
        #settings:hover .tooltip-text { left: 21%; }
        #new-po:hover .tooltip-text { left: 43%; }
        #batch-delete:hover .tooltip-text { left: 49%; }
        #batch-delete:hover .tooltip-text::after { left: 75%; }

        /* ROOT CONTAINER */
        #po-list-toolbar {
          display: flex;
          padding: 5px 0;
        }
        /* ROOT CONTAINER END */
      `}
      </style>
    </React.Fragment>
  )
}
